<template>
  <AccountContextWrapper>
    <div v-if="acctUid" class="row">
      <div class="col-6">
        <h4>Create Banking Institution</h4>
        <CreateBankingInstView :acctUid="acctUid" />
      </div>
      <div class="col-6">
        <h4>List Banking Institutions</h4>
        <ListBankingInstsView :acctUid="acctUid" />
      </div>
    </div>
  </AccountContextWrapper>
</template>

<script>
import { mapActions } from "vuex";
import {
  userSession as userSessNs,
  userAccount as userAcctNs,
} from "@/store/namespaces.js";

import AccountContextWrapper from "@/components/molecules/AccountContextWrapper.vue";
import CreateBankingInstView from "@/components/BankingInstitutions/CreateView.vue";
import ListBankingInstsView from "@/components/BankingInstitutions/ListView.vue";

export default {
  name: "IndexView",
  data() {
    return {};
  },
  components: {
    AccountContextWrapper,
    CreateBankingInstView,
    ListBankingInstsView,
  },
  computed: {
    acctUid() {
      return this.$store.getters[`${userAcctNs}/getSelectedAcctUid`];
    },
  },
  methods: {
    ...mapActions({
      getUserInfo: `${userSessNs}/getUserInfo`,
    }),
  },
};
</script>
